'use client';
import React from 'react';
import { useOpenHoursConfiguration } from '../../hooks/useOpenHoursConfiguration';
import PhoneIcon from '../atoms/icons/phone';

const TopRow = () => {
  const openHours = useOpenHoursConfiguration();

  const weekday = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];

  const day = weekday[new Date().getDay()];

  const dayOfWeek = `field_open_hours_${day}_string`;

  return (
    <div className="bg-yellow-60 w-full mx-auto flex flex-nowrap justify-center items-center py-2 relative z-60">
      <div className="font-bold text-sm">
        <a
          href={`tel://${openHours.field_phone_number_string}`}
          className="flex flex-nowrap items-center  justify-center no-underline"
        >
          <PhoneIcon />
          <span className="ml-2 text-sm ">
            {openHours['field_phone_number_string']}
          </span>
        </a>
      </div>
      <div className="ml-3 text-xs">{openHours[dayOfWeek]}</div>
    </div>
  );
};

export default TopRow;
